var map = {
	"./0C.svg": 8094,
	"./0D.svg": 3569,
	"./0H.svg": 1637,
	"./0S.svg": 862,
	"./2C.svg": 9684,
	"./2D.svg": 7387,
	"./2H.svg": 7471,
	"./2J.svg": 3693,
	"./2S.svg": 1300,
	"./3C.svg": 8167,
	"./3D.svg": 3240,
	"./3H.svg": 780,
	"./3S.svg": 6663,
	"./4C.svg": 1322,
	"./4D.svg": 8181,
	"./4H.svg": 7201,
	"./4S.svg": 2410,
	"./5C.svg": 1501,
	"./5D.svg": 1282,
	"./5H.svg": 3494,
	"./5S.svg": 413,
	"./6C.svg": 3216,
	"./6D.svg": 687,
	"./6H.svg": 3899,
	"./6S.svg": 3904,
	"./7C.svg": 3411,
	"./7D.svg": 6668,
	"./7H.svg": 2808,
	"./7S.svg": 8083,
	"./8C.svg": 1270,
	"./8D.svg": 8601,
	"./8H.svg": 877,
	"./8S.svg": 3334,
	"./9C.svg": 8985,
	"./9D.svg": 5750,
	"./9H.svg": 3506,
	"./9S.svg": 1017,
	"./AC.svg": 2289,
	"./AD.svg": 462,
	"./AH.svg": 5434,
	"./AS.svg": 9489,
	"./JC.svg": 6060,
	"./JD.svg": 6451,
	"./JH.svg": 7271,
	"./JS.svg": 3468,
	"./KC.svg": 2831,
	"./KD.svg": 6944,
	"./KH.svg": 2004,
	"./KS.svg": 4447,
	"./QC.svg": 6497,
	"./QD.svg": 9118,
	"./QH.svg": 6618,
	"./QS.svg": 6001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4117;